<template>
  <div class="headerContract">
    <div class="headerContract__title" v-html="header.head"></div>
    <div v-for="(subtitle, key) in header.subtitle" :key="key">
      <a target="_blank" v-if="subtitle.url !== false" :href="subtitle.url">
        {{ subtitle.text }}
      </a>
      <p v-if="subtitle.url === false">{{ subtitle.text }}</p>
    </div>
    <div v-if="header.info.strategy" class="headerContract__strategyTitle"
         v-html="header.info.strategy.title"></div>
    <div v-if="header.info.strategy" class="headerContract__strategyText"
         v-html="header.info.strategy.value"></div>
  </div>
</template>

<script>
export default {
  name: "HeaderContractComponents",
  props: ["header"]
};
</script>